import { useEffect } from "react";
import { useRunStream } from "../../hooks/useRunStream.js";
import styles from "./LiveStream.module.css";

interface LiveStreamProps {
  runId: string;
  onComplete: () => void;
}

export function LiveStream({ runId, onComplete }: LiveStreamProps) {
  const { results, summary, isComplete } = useRunStream(runId);

  useEffect(() => {
    if (isComplete) {
      const timer = setTimeout(onComplete, 3000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isComplete, onComplete]);

  const total = summary?.total_checks ?? results.length;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.progress}>
          {results.length}{total > results.length ? `/${total}` : ""} checks
          {isComplete ? " — complete" : " running…"}
        </span>
        {isComplete && summary && (
          <span className={styles.score}>score: {summary.score}%</span>
        )}
      </div>
      <div className={styles.results}>
        {results.map((r, i) => (
          <div key={i} className={`${styles.result} ${r.ok ? styles.pass : styles.fail}`}>
            <span>{r.ok ? "✓" : "✗"}</span>
            <code>{r.slug}</code>
            {r.detail && <span className={styles.detail}>{r.detail}</span>}
            <span className={styles.dur}>{r.duration_ms}ms</span>
          </div>
        ))}
      </div>
    </div>
  );
}
